module.exports = __webpack_public_path__ + "static/media/down_arrow.e7cbc8de.svg";